module.exports = {"610122001":"蓝关街道","610122101":"洩湖镇","610122102":"华胥镇","610122103":"前卫镇","610122104":"汤峪镇","610122105":"焦岱镇","610122106":"玉山镇","610122107":"三里镇","610122108":"普化镇","610122109":"葛牌镇","610122110":"灞源镇","610122111":"九间房镇","610122112":"蓝桥镇","610122113":"辋川镇","610122115":"厚镇","610122116":"三官庙镇","610122118":"安村镇","610122119":"孟村镇","610122120":"小寨镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610122.json
// module id = 2923
// module chunks = 0